module.exports = __webpack_public_path__ + "img/diners-v2.svg";